import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { beginSignIn } from 'actions/creators/Auth'

class SignIn extends React.Component {
  componentDidMount = () => {
    this.props.beginSignIn()
    this.props.router.push('/')
  }

  render() {
    return <h1>SignIn</h1>
  }
}

export default withRouter(connect((s) => s, { beginSignIn })(SignIn))



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/SignIn.jsx